/* THIS FILE WAS AUTO-GENERATED SEE README.MD AND generation/src/icons FOR MORE DETAILS */
import "./styles.scss";

import React from "react";
import PropTypes from "prop-types";
import { ICON_TYPES, ICON_SIZES } from "../../../constants/icons";
import { IconWrapper } from "./IconWrapper";

export const PhoneUpIcon = ({ className, iconType, iconSize, ...props }) => {
    if (iconType === ICON_TYPES.OUTLINE) {
        return (
            <IconWrapper
                className={className}
                iconSize={iconSize}
                iconType={iconType}
                iconName="PhoneUp"
                {...props}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.0538 4.25763L23.9227 4.12253C24.9391 4.13506 25.7014 4.73168 26.0716 5.1018C26.9394 5.96961 27.1253 6.88952 26.5142 9.66181C25.5929 13.8415 23.4177 17.6551 20.4147 20.6582C17.2327 23.8401 13.598 25.8363 9.41836 26.7577C6.64607 27.3688 5.72616 27.1828 4.85836 26.315C4.46613 25.9228 3.86399 25.166 3.87908 24.1661L4.01418 20.2972C4.01418 19.125 5.32203 17.88 6.60573 17.7057C7.60059 17.5706 8.32524 17.3618 9.38151 16.9687C10.989 16.3706 12.0222 16.9073 13.2258 18.111C14.1347 17.5951 15.1114 16.7691 15.8185 16.062C16.5256 15.3549 17.3517 14.3782 17.8675 13.4693C16.6639 12.2656 16.1272 11.2325 16.7253 9.62496C17.1183 8.56869 17.3271 7.84404 17.4622 6.84918C17.6366 5.56548 18.7727 4.25763 20.0538 4.25763ZM5.87884 24.208L6.01369 20.3463C6.01651 20.3395 6.02052 20.3305 6.02612 20.3194C6.05792 20.256 6.12286 20.1596 6.23125 20.0529C6.47005 19.818 6.73664 19.7063 6.87487 19.6875C8.06062 19.5265 8.93407 19.2692 10.079 18.8432C10.536 18.6732 10.7129 18.7239 10.8042 18.7553C10.9788 18.8154 11.2769 18.9904 11.8116 19.5252L12.8885 20.6021L14.2131 19.8504C15.3356 19.2132 16.4557 18.2532 17.2327 17.4762C18.0098 16.6991 18.9698 15.5791 19.6069 14.4565L20.3587 13.132L19.2818 12.0551C18.747 11.5203 18.572 11.2222 18.5118 11.0476C18.4804 10.9564 18.4297 10.7794 18.5997 10.3224C19.0258 9.17752 19.283 8.30407 19.444 7.11831C19.4695 6.93102 19.588 6.66397 19.7887 6.45405C19.9509 6.28436 20.056 6.26036 20.0657 6.25763H20.0887L23.929 6.12353C24.0362 6.13017 24.1542 6.1648 24.2874 6.23691C24.439 6.31896 24.5699 6.42861 24.6573 6.51602C24.7737 6.63237 24.8059 6.68914 24.8157 6.70821C24.8223 6.72094 24.8457 6.76622 24.8605 6.89557C24.8986 7.22793 24.8605 7.87318 24.5611 9.23128C23.7268 13.0161 21.7503 16.4941 19.0005 19.2439C16.08 22.1645 12.7836 23.9679 8.98783 24.8046C7.62973 25.1039 6.98449 25.1421 6.65212 25.104C6.52278 25.0891 6.47766 25.0658 6.46493 25.0593C6.44586 25.0494 6.38892 25.0171 6.27257 24.9008C6.16221 24.7904 6.05026 24.6549 5.97266 24.5123C5.90241 24.3833 5.87981 24.2857 5.87884 24.208ZM6.00782 20.3624L6.00823 20.3609L6.00782 20.3624Z"
                />
            </IconWrapper>
        );
    }

    if (iconType === ICON_TYPES.FILLED) {
        return (
            <IconWrapper
                className={className}
                iconSize={iconSize}
                iconType={iconType}
                iconName="PhoneUp"
                {...props}>
                <path d="M26.5142 9.66181C27.1253 6.88952 26.9394 5.96961 26.0716 5.1018C25.7014 4.73168 24.9391 4.13506 23.9227 4.12253L20.0538 4.25763C18.7727 4.25763 17.6366 5.56548 17.4622 6.84918C17.3271 7.84404 17.1183 8.56869 16.7253 9.62496C16.1272 11.2325 16.6639 12.2656 17.8675 13.4693C17.3517 14.3782 16.5256 15.3549 15.8185 16.062C15.1114 16.7691 14.1347 17.5951 13.2258 18.111C12.0222 16.9073 10.989 16.3706 9.38151 16.9687C8.32524 17.3618 7.60059 17.5706 6.60573 17.7057C5.32203 17.88 4.01418 19.125 4.01418 20.2972L3.87908 24.1661C3.86399 25.166 4.46613 25.9228 4.85836 26.315C5.72616 27.1828 6.64607 27.3688 9.41836 26.7577C13.598 25.8363 17.2327 23.8401 20.4147 20.6582C23.4177 17.6551 25.5929 13.8415 26.5142 9.66181Z" />
            </IconWrapper>
        );
    }

    if (iconType === ICON_TYPES.CIRCLE) {
        return (
            <IconWrapper
                className={className}
                iconSize={iconSize}
                iconType={iconType}
                iconName="PhoneUp"
                {...props}>
                <g clipPath="url(#clip0_1242_589)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.85786 5.85787C13.6683 -1.95262 26.3317 -1.95262 34.1421 5.85787C41.9526 13.6684 41.9526 26.3317 34.1421 34.1421C26.3316 41.9526 13.6684 41.9526 5.85786 34.1421C-1.95262 26.3317 -1.95262 13.6684 5.85786 5.85787ZM27.4246 11.5147C28.0755 12.1656 28.215 12.8555 27.7566 14.9347C27.0656 18.0695 25.4343 20.9297 23.182 23.182C20.7955 25.5685 18.0695 27.0656 14.9347 27.7566C12.8555 28.215 12.1656 28.0755 11.5147 27.4246C11.2206 27.1305 10.7689 26.5628 10.7803 25.813L10.8816 22.9113C10.8816 22.0321 11.8625 21.0984 12.8252 20.9676C13.5714 20.8663 14.1149 20.7097 14.9071 20.4149C16.1127 19.9663 16.8876 20.3689 17.7903 21.2716C18.472 20.8847 19.2045 20.2652 19.7348 19.7348C20.2652 19.2045 20.8847 18.472 21.2716 17.7903C20.3689 16.8876 19.9663 16.1127 20.4149 14.9071C20.7097 14.1149 20.8663 13.5714 20.9676 12.8252C21.0984 11.8625 21.9505 10.8816 22.9113 10.8816L25.813 10.7803C26.5753 10.7897 27.147 11.2371 27.4246 11.5147Z"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1242_589">
                        <rect width="40" height="40" />
                    </clipPath>
                </defs>
            </IconWrapper>
        );
    }

    return null;
};

PhoneUpIcon.propTypes = {
    className: PropTypes.string,
    iconType: PropTypes.oneOf(Object.values(ICON_TYPES)),
    iconSize: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

PhoneUpIcon.defaultProps = {
    className: undefined,
    iconType: ICON_TYPES.OUTLINE,
    iconSize: ICON_SIZES.MEDIUM,
};
